import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=150fbf90&scoped=true"
var script = {}
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=150fbf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fbf90",
  null
  
)

export default component.exports